import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

import screenshot from '../assets/screen-shot.png';

import StepI from '../assets/step1.png';
import StepII from '../assets/step2.png';
import StepIII from '../assets/step3.png';
import StepIV from '../assets/step4.png';

export default {
  email,
  mobile,
  screenshot,
  StepI,
  StepII,
  StepIII,
  StepIV,
};
